import * as React from 'react';

import { IProfile, IAddProps } from '../types';

import Form from './Form';

export default class Add extends React.Component<IAddProps> {
  onSubmit = async (values: IProfile) => {
    await this.props.add(values);
    this.props.close();
  };

  render() {
    return (
      <Form
        id="new"
        initialValues={{
          name: '',
          shortDomainWhitelisted: '',
          shortDomainNonWhitelisted: '',
          active: false,
        }}
        onSubmit={this.onSubmit}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Profiles/components/New.tsx